/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Entry_MissingInputs */

const en_mobile_faq_entry_missing = /** @type {(inputs: Mobile_Faq_Entry_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This FAQ entry doesn’t exist.`)
};

const es_mobile_faq_entry_missing = /** @type {(inputs: Mobile_Faq_Entry_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta entrada de preguntas frecuentes no existe.`)
};

/**
* | output |
* | --- |
* | "This FAQ entry doesn’t exist." |
*
* @param {Mobile_Faq_Entry_MissingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_entry_missing = /** @type {((inputs?: Mobile_Faq_Entry_MissingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Entry_MissingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_entry_missing(inputs)
	return en_mobile_faq_entry_missing(inputs)
});